import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import content from "@/seo/content.json";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const QA = content.pricingFaq;

const DEPOSIT = " Want to lock in your spot now? Pay a booking deposit when you request a study and it's credited in full on your final invoice.";

export const PricingFaq = () => {
  const [deposit, setDeposit] = useState(false);
  useEffect(() => { api.get("/public/pricing").then((r) => setDeposit(r.data.deposit_percent > 0)).catch(() => {}); }, []);
  return (
  <section className="max-w-3xl mx-auto px-4 sm:px-6 py-16" data-testid="pricing-faq">
    <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mb-6">Pricing questions</h2>
    <Accordion type="single" collapsible>
      {QA.map(([q, a], i) => (
        <AccordionItem key={q} value={`p${i}`} className="border-slate-800">
          <AccordionTrigger data-testid={`pricing-faq-${i}`} className="text-left font-display">{q}</AccordionTrigger>
          <AccordionContent className="text-slate-400 leading-relaxed">{a}{i === 2 && deposit ? DEPOSIT : ""}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
  );
};
